import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { Component, output, input } from '@angular/core';

import { IconButtonComponent, IconName } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-sidebar-filter',
  styleUrls: ['./sidebar-filter.component.less'],
  templateUrl: './sidebar-filter.component.html',
  imports: [IconButtonComponent, NgTemplateOutlet],
})
export class SidebarFilterComponent {
  public readonly name = input<string>(undefined!);
  public readonly icon = input<IconName>(undefined!);
  public readonly minimized = input<boolean>(false);
  public readonly contentTemplate = input<TemplateRef<any>>(undefined!);
  public readonly contentTemplateContext = input<Record<string, any>>(undefined!);
  public readonly removable = input<boolean>(true);

  public remove = output<void>();
}
